import { trimStrings } from '../../general-utilities/string-utils';
import { Device, DeviceBackend, DeviceCreate, DeviceInput } from '../../models/Device';

export const serializeDeviceFromBackend = (backend: DeviceBackend): Device => ({
  id: backend.id,
  name: backend.name,
  description: backend.description,
  organization: backend.organization,
  is_active: backend.is_active,
  release_date: new Date(backend.release_date),
  serial_number: backend.serial_number,
  device_uuid: backend.device_uuid,
  remote_id_number: backend.remote_id_number,
  faa_reg_number: backend.faa_reg_number,
  device_type: backend.device_type,
  created_at: new Date(backend.created_at),
  updated_at: new Date(backend.updated_at),
  heart_beat: backend.heart_beat
});

export const serializeDeviceCreateToBackend = (input: DeviceInput): DeviceCreate => {
  const trimmedInput = trimStrings(input);

  return {
    name: trimmedInput.name,
    device_type: trimmedInput.device_type,
    description: trimmedInput.description,
    organization: trimmedInput.organization,
    is_active: trimmedInput.is_active,
    release_date: trimmedInput.release_date,
    serial_number: trimmedInput.serial_number,
    device_uuid: trimmedInput.device_uuid,
    remote_id_number: trimmedInput.remote_id_number,
    faa_reg_number: trimmedInput.faa_reg_number
  };
};
